module.exports = __webpack_public_path__ + "static/media/CSM.d0637b2b.webp";